import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { toaster } from 'utils/toast-wrapper'
import {
  MEMBER_INVOICE_TABLE,
  MEMBER_BALANCE_HISTORY_TABLE,
} from 'constants/tables'

import ApproveButtonComponent from './component'

export const ApproveMemberInvoicePayment = combine(
  withTableController({ id: MEMBER_INVOICE_TABLE }),
  withTableController({ id: MEMBER_BALANCE_HISTORY_TABLE }),
  withContext(
    'adminMemberInvoiceService',
    ServicesContext,
    ({ adminMemberInvoiceService }) => adminMemberInvoiceService
  ),
  withCallback(
    'onApproveMemberInvoice',
    ({ adminMemberInvoiceService, table }, { value }) =>
      async () => {
        await adminMemberInvoiceService.acceptMemberInvoicePayment(value.number)
        toaster.success('Invoice approved successfully.')
        table.refresh()
      },
    ['value']
  )
)(ApproveButtonComponent)
